/**
 * Taxonomía única de `categoria_id` en productos (Firestore).
 * Usada en catálogo (filtros) y en publicación.
 */

/** @typedef {{ id: string, label: string, card: string, seccion: 'comida'|'hogar'|'taller'|'varios' }} CategoriaDef */

/** @type {CategoriaDef[]} */
export const CATEGORIAS_PRODUCTO = [
  { id: 'comidas_caseras', label: 'Comidas caseras', card: 'Comidas caseras', seccion: 'comida' },
  { id: 'postres', label: 'Postres', card: 'Postres', seccion: 'comida' },
  { id: 'pasteleria', label: 'Pastelería', card: 'Pastelería', seccion: 'comida' },
  { id: 'hogar', label: 'Hogar', card: 'Hogar', seccion: 'hogar' },
  { id: 'muebles', label: 'Muebles', card: 'Muebles', seccion: 'hogar' },
  { id: 'iluminacion', label: 'Iluminación', card: 'Iluminación', seccion: 'hogar' },
  { id: 'ferreteria', label: 'Ferretería', card: 'Ferretería', seccion: 'taller' },
  { id: 'herramientas', label: 'Herramientas', card: 'Herramientas', seccion: 'taller' },
  { id: 'juguetes', label: 'Juguetes', card: 'Juguetes', seccion: 'varios' },
  { id: 'tecnologia', label: 'Tecnología', card: 'Electrónica', seccion: 'varios' },
  { id: 'indumentaria', label: 'Indumentaria', card: 'Ropa', seccion: 'varios' },
  { id: 'general', label: 'General', card: 'General', seccion: 'varios' },
];

const ETIQUETA_SECCION = {
  comida: 'Comida',
  hogar: 'Hogar y decoración',
  taller: 'Ferretería y taller',
  varios: 'Otros',
};

/** Orden de pills en home (ids; '' = Todos). */
export const ORDEN_PILLS_CATALOGO = [
  '',
  'comidas_caseras',
  'postres',
  'pasteleria',
  'hogar',
  'muebles',
  'ferreteria',
  'herramientas',
  'iluminacion',
  'juguetes',
  'tecnologia',
  'indumentaria',
  'general',
];

export function buildMapsCategoria() {
  const ETIQUETA_CATEGORIA = {};
  const ETIQUETA_CATEGORIA_CARD = {};
  for (const c of CATEGORIAS_PRODUCTO) {
    ETIQUETA_CATEGORIA[c.id] = c.label;
    ETIQUETA_CATEGORIA_CARD[c.id] = c.card;
  }
  return { ETIQUETA_CATEGORIA, ETIQUETA_CATEGORIA_CARD };
}

/** Chips para la home: { value, label } */
export function getChipsCatalogoHome() {
  const { ETIQUETA_CATEGORIA } = buildMapsCategoria();
  return ORDEN_PILLS_CATALOGO.map((id) =>
    id === ''
      ? { value: '', label: 'Todos' }
      : { value: id, label: ETIQUETA_CATEGORIA[id] || id }
  );
}

/** Opciones agrupadas para `<select>` al publicar. */
export function getCategoriaOpcionesPorSeccion() {
  const ordenSeccion = ['comida', 'hogar', 'taller', 'varios'];
  return ordenSeccion.map((key) => ({
    seccionKey: key,
    seccionLabel: ETIQUETA_SECCION[key],
    items: CATEGORIAS_PRODUCTO.filter((c) => c.seccion === key).map((c) => ({
      id: c.id,
      label: c.label,
    })),
  }));
}
